import getExerciseMaterialData from './getExerciseMaterialData'
import getCombinedExercisesData from './getCombinedExercisesData'

/**
 * Calculate and convert the data from Materials into an array of objects to be used in different components
 *
 * @param exercises
 * @returns {*[]}
 */
export default function getTrainingMaterials(entry, t) {
  if (!entry) return null
  const exercises = getCombinedExercisesData(entry)
  const trainingTypeCategory = entry?.trainingTypeCategory?.[0]?.id
  // circuit and tournament trainingTypeCategory's
  const trainingTotalCheck = parseInt(trainingTypeCategory) === 372 || parseInt(trainingTypeCategory) === 373
  const data = []
  const types = [
    'ballCount',
    'coneCount',
    'goalSmallCount',
    'goalMediumCount',
    'goalLargeCount',
    'goalIndoorCount',
    'shirt1Count',
    'shirt2Count',
    'shirt3Count',
    'obstacles1Count',
    'obstacles2Count',
    'obstacles3Count',
    'softballCount',
    'korfballCount',
    'benchCount',
    'vaultingBoxCount',
    'thinMatCount',
    'longMatCount',
    'thickMatCount'
  ]

  if (exercises.length >= 1) {
    exercises.forEach((exercise) => {
      types.forEach((type) => {
        // Init material type count
        if (typeof data[type] === 'undefined') data[type] = 0

        // Current exercises material type count
        const currentCount = exercise?.exerciseContent[0]?.exerciseFigure?.[0]?.[type]

        if (typeof currentCount === 'number') {
          data[type] = trainingTotalCheck ? parseInt(data[type] + currentCount) : Math.max(data[type], currentCount)
        }
      })
    })
  }
  return getExerciseMaterialData(data, t)
}
